import { useQuery } from '@tanstack/react-query';
import { fetchFeaturedLeagues } from '../../api/sportsbook-api';
import { RefetchInterval, StaleTime } from '../../sportsbook-constants';
import { SPORTSBOOK_QUERY_KEY } from '../queries-constants';
import trimLeagueName from '../../utils/trim-league-name';

type Options = {
	refetchInterval?: RefetchInterval;
};

const useQueryFeaturedLeagues = (options?: Options) =>
	useQuery({
		queryKey: [SPORTSBOOK_QUERY_KEY, 'featured-leagues'],
		queryFn: fetchFeaturedLeagues,
		staleTime: StaleTime.ZERO,
		refetchInterval: options?.refetchInterval,
		meta: {
			errorMessage: 'Failed to fetch featured leagues'
		},
		select: data =>
			data.map(league => ({
				...league,
				name: trimLeagueName(league.name)
			}))
	});

export default useQueryFeaturedLeagues;
